import {BankStatisticRepository} from '@/modules/bank/domain/BankStatisticRepository'
import {BankDeliveryRepository} from '@/modules/bank/domain/BankDeliveryRepository'
import {BankStatisticScreenData} from '@/modules/bank/domain/BankStatisticScreenData'

export class BankStatisticsComponent{    
    bank_statistic_repo:BankStatisticRepository
    bank_delivery_repo:BankDeliveryRepository
    screen_data: BankStatisticScreenData

  
    constructor(bank_statistic_repo, bank_delivery_repo, screen_data){
        this.bank_statistic_repo = bank_statistic_repo
        this.bank_delivery_repo = bank_delivery_repo
        this.screen_data = screen_data
    }
  
    async get_bank_statistics(contract_id){        
        this.screen_data.setLoading(true)

        let stats = await this.bank_statistic_repo.get_data(contract_id)
        this.screen_data.setStatistics(stats)
        this.screen_data.setLoading(false)
    }
    async get_user_bank_contracts(user_id){                

        let contracts = await this.bank_delivery_repo.get_data(user_id)
        this.screen_data.setContracts(contracts)
    }        
  }